import React from 'react';
import mail from '../assets/ic_outline-email.png';
import call from '../assets/call.png';
import '../styles/NeedHelp.css';
import cs from '../assets/cs.png';


const NeedHelp = () => {
  return (
    <div className='need-help'>
    <div className='need-help-container'>
      <img src={cs} style={{width:'30%',height:'auto',margin:'15px'}} alt='Customer Support' className='need-help-image' />
      <div className='need-help-text'>
      <div className='need-help-title'>Customize Your Tour</div>
      <div className='need-help-contact-info'><img src={call}/>: 9736242827</div>
      <div className='need-help-contact-info'><img src={mail}/>: Holidays@vigovia.com</div>
      </div>
      
    </div>
    <button className='raise-a-query'>Talk to Holiday Expert</button>
    
    </div>
    
  );
};

export default NeedHelp;
